<div class="row">
    <cc-icon
        [icon]="'error'"
        [size]="'xlarge'"
        [disabled]="true"
        [color]="'var(--ntfy-error-color)'"
    >
    </cc-icon>
    <h3>Errors occurred during initialization</h3>
</div>

<div class="errors">
    @for (error of errors; track $index) {
        <div class="error">
            <div class="message">{{error.message}}</div>
            <div class="more" (click)="showDetail($event, error)">more...</div>
        </div>
    }
</div>

@if (detail) {
    <div [ccModal]="modalOptions" (dismissed)="detail = undefined" class="details">
        <div class="row">
            <div class="label">route:</div><div class="text">{{detail.url}}</div>
        </div>
        @if (detail.requestParameters) {
            <div class="row">
                <div class="label">request params:</div><div class="text">{{detail.requestParameters | json}}</div>
            </div>
        }
        <div class="row">
            <div class="label">status:</div><div class="text">{{detail.statusCode}}</div>
        </div>
        <div class="row">
            <div class="label">body:</div><div class="text">{{detail.body | json}}</div>
        </div>
    </div>
}
